module.exports = __webpack_public_path__ + "media/images/shared/delivery/airtranss-8b628a7f5a5f6ec73176b802e7c3b717.jpg";